import Yup from '../../../../utils/yup';
import { rucValidator } from '../../../Validations';

// eslint-disable-next-line import/prefer-default-export
export function validationFunctionBankAccount(values) {
  const errors = {};
  // Custom Validations
  return errors;
}
